import { InjectionToken, inject } from '@angular/core';
import { WINDOW } from './window';

export const CACHE_STORAGE = new InjectionToken('tvd.cache-storage', {
  factory: () => {
    const ref = inject(WINDOW);
    return ref.caches;
  },
});
